<template>
  <div>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <base-list-management
      ref="baseListManagementRef"
      :configData.sync="configData"
    >
      <template v-slot:custom-export>
        <PublicExport
          exportTitle="发放领取记录导出"
          exportTemplate="CouponUserGet"
          :getSearchData="getExportParams"
          templateCode="vehicle-customer-get-coupon-page"
          :getSearchCondition="getSearchCondition"
        >
          <template v-slot:export-button="{ openDialog, exportBtnText }">
            <el-button type="primary" size="small" @click="openDialog">
              {{ exportBtnText }}
            </el-button>
          </template>
        </PublicExport>
      </template>
    </base-list-management>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { configDataFn } from '../config/grantRecordList'
import { generateExportCondition } from '@/utils/exportUtils.js'

export default {
  name: 'CouponGrantReceiveRecord',
  data() {
    const initialFormData = {}
    if (this.$route.query.couponId !== undefined && this.$route.query.couponId !== null) {
      initialFormData.couponId = String(this.$route.query.couponId)
    }
    return {
      configData: configDataFn({
        activeTab: 'grant',
        couponTemplateId: this.$route.query.activityId || '',
        initialFormData,
        onJumpDriverList: this.handleJumpDriverList,
        onJumpCouponActivity: this.handleJumpCouponActivity,
        createElement: this.$createElement,
      }),
    }
  },
  methods: {
    getExportParams() {
      if (!this.$refs.baseListManagementRef) return {}
      return this.$refs.baseListManagementRef.getParams()
    },
    getSearchCondition() {
      const formList = this.configData?.formData?.list || []
      const model = this.configData?.formData?.formProps?.model || {}
      const condition = formList.map((item) => {
        const { el, itemConfig: { label, prop: key } } = item
        const val = model[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      condition.push({
        label: '记录类型',
        matchValue: '发放领取记录',
      })
      return condition
    },
    handleJumpDriverList(customerName) {
      this.$router.push({
        path: '/driver/customerManage',
        query: {
          type: 'person',
          customerName,
        },
      })
    },
    handleJumpCouponActivity(activityId) {
      this.$router.push({
        path: '/activity/coupon/list',
        query: {
          activityId,
        },
      })
    },
  },
}
</script>
